import _isNumber from "lodash/isNumber";
import calculateMip from '@nerdwallet/mortgage-utils/calculate-mip';
import { LOAN_TYPE_CONVENTIONAL, LOAN_TYPE_VA } from '@nerdwallet/home-constants';
import calculatePmi from './calculate-pmi';
/**
 * Estimates the monthly mortgage insurance premium for FHA loans.
 * Should be 0 if the loan has more than 20% down payment
 * @module lib/estimate-mip
 * @param {number=} monthlyMortgageInsurance Optional override for monthly mortgage insurance
 * @param {number} creditScore Credit score
 * @param {number} suggestedPurchasePrice  The purchase price (or output of this calc)
 * @param {number=} outputDownPayment  The down payment from the last iteration of this calculation
 * @param {number=} downPaymentOverride  Overridden down payment
 */

export default function estimateMortgageInsurancePayment(_ref) {
  var monthlyMortgageInsurance = _ref.monthlyMortgageInsurance,
      creditScore = _ref.creditScore,
      loanProgram = _ref.loanProgram,
      loanType = _ref.loanType,
      downPayment = _ref.downPayment,
      loanAmount = _ref.loanAmount;

  if (_isNumber(monthlyMortgageInsurance)) {
    return monthlyMortgageInsurance;
  }

  if (loanType === LOAN_TYPE_VA) {
    return 0;
  }

  var purchasePrice = loanAmount + downPayment;
  var annualPremium = loanType === LOAN_TYPE_CONVENTIONAL ? calculatePmi({
    creditScore: creditScore,
    loanAmount: loanAmount,
    loanProgram: loanProgram,
    purchasePrice: purchasePrice
  }) : calculateMip({
    loanAmount: loanAmount,
    loanProgram: loanProgram,
    purchasePrice: purchasePrice
  });
  return annualPremium / 12;
}